<template>
  <div class="animated fadeIn">
    <b-row class="mb-4">
      <b-col md="12" lg="8" xl="4">
        <h2 v-if="!chart_activated" class="pr-3 my-1 mb-3 mb-lg-0 pageinfo text-center text-lg-left">Dashboard</h2>
        <h2 v-else class="pr-3 my-1 mb-3 mb-lg-0 pageinfo text-center text-lg-left">Dashboard - Trucking Company</h2>
      </b-col>
    </b-row>
    <b-row v-if="!chart_activated" class="mb-4">
      <b-col md="3" lg="2" v-show="view">
        <b-dropdown
          class="custom_dropdown custom_dropdown_b my-1"
          @show="activate_custom_backdrop"
          @hidden="deactivate_custom_backdrop"
          variant="info"
          :text="ec_filter"
          title="Energy Company"
        >
          <b-dropdown-item
            @click="ecFilter(energy_company_filter.company_name, energy_company_filter.id)"
            v-for="energy_company_filter in energy_companies_filter"
          >{{energy_company_filter.company_name}}</b-dropdown-item>
        </b-dropdown>
      </b-col>
      <b-col md="3" lg="2" v-show="view">
        <b-dropdown
          class="custom_dropdown custom_dropdown_b my-1"
          @show="activate_custom_backdrop"
          @hidden="deactivate_custom_backdrop"
          variant="info"
          :text="tc_filter"
          title="Trucking Company"
        >
          <b-dropdown-item @click="tcFilter('All Trucking Companies', 0)">All Trucking Companies</b-dropdown-item>
          <b-dropdown-item
            @click="tcFilter(trucking_company_filter.name, trucking_company_filter.id)"
            v-for="trucking_company_filter in trucking_companies_filter"
          >{{trucking_company_filter.name}}</b-dropdown-item>
        </b-dropdown>
      </b-col>
      <b-col md="3" lg="2" class="my-1" title="Initial Date">
        <b-form-input
          id="haul_start_datetime"
          v-model="filter_by.initial_date"
          @input="iFilter()"
          type="date"
        ></b-form-input>
      </b-col>
      <b-col md="3" lg="2" class="my-1" title="End date">
        <b-form-input
          id="haul_end_datetime"
          v-model="filter_by.end_date"
          @input="eFilter()"
          type="date"
        ></b-form-input>
      </b-col>
      <b-col md="3" lg="2" v-if="role=='super_admin' || role=='super_analyst' || role=='operations_manager'">
        <b-dropdown
          class="custom_dropdown custom_dropdown_b my-1"
          @show="activate_custom_backdrop"
          @hidden="deactivate_custom_backdrop"
          variant="info"
          :text="oa_filter"
          title="Operating Area"
        >
          <b-dropdown-item @click="oaFilter('All Operating Areas', 0)">All Operating Areas</b-dropdown-item>
          <b-dropdown-item
            @click="oaFilter(operating_area_filter.name, operating_area_filter.id)"
            v-for="operating_area_filter in operating_areas_filter"
          >{{operating_area_filter.name}}</b-dropdown-item>
        </b-dropdown>
      </b-col>
      <b-col md="1">
        <b-btn @click="clearFilters()" class="pull-right pull-sm-left my-1" variant="info">Clear</b-btn>
      </b-col>
      <b-col>
        <b-btn
          class="pull-right my-1"
          v-b-popover.hover.top="'Activate/Deactivate bbl'"
          variant="info"
          @click="bbl()"
        >
          <i class="fa fa-bullseye"></i>
        </b-btn>
         <b-btn v-if="role =='super_admin'" 
                class="pull-right my-1" 
                @click="activate_chart_click()"  
                v-b-popover.hover.top="'Activate/Deactivate Chart'" 
                variant="info"><i class="fa fa-bar-chart"></i></b-btn>
      </b-col>
    </b-row>
    <b-row v-else class="mb-4">

      <b-col md="3" lg="2" v-show="view">
        <b-dropdown
          class="custom_dropdown custom_dropdown_b my-1"
          @show="activate_custom_backdrop"
          @hidden="deactivate_custom_backdrop"
          variant="info"
          :text="tc_filter1"
          title="Trucking Company"
        >
          <b-dropdown-item @click="tcFilter1('All Trucking Companies', 0)">All Trucking Companies</b-dropdown-item>
          <b-dropdown-item
            @click="tcFilter1(trucking_company_filter.name, trucking_company_filter.id)"
            v-for="trucking_company_filter in trucking_companies_filter1"
          >{{trucking_company_filter.name}}</b-dropdown-item>
        </b-dropdown>
      </b-col>
      <b-col md="3" lg="2" v-show="view">
        <b-dropdown
          class="custom_dropdown custom_dropdown_b my-1"
          @show="activate_custom_backdrop"
          @hidden="deactivate_custom_backdrop"
          variant="info"
          :text="ec_filter1"
          title="Energy Company"
        >
          <b-dropdown-item @click="ecFilter1('All Energy Companies', 0)">All Energy Companies</b-dropdown-item>
          <b-dropdown-item
            @click="ecFilter1(energy_company_filter.name, energy_company_filter.id)"
            v-for="energy_company_filter in energy_companies_filter1"
          >{{energy_company_filter.name}}</b-dropdown-item>
        </b-dropdown>
      </b-col>
      <b-col md="3" lg="2" class="my-1" title="Initial Date">
        <b-form-input
          id="haul_start_datetime"
          v-model="filter_by1.initial_date"
          @input="iFilter1()"
          type="date"
        ></b-form-input>
      </b-col>
      <b-col md="3" lg="2" class="my-1" title="End date">
        <b-form-input
          id="haul_end_datetime"
          v-model="filter_by1.end_date"
          @input="eFilter1()"
          type="date"
        ></b-form-input>
      </b-col>
      <b-col md="3" lg="2" v-if="role=='super_admin' || role=='super_analyst' || role=='operations_manager'">
        <b-dropdown
          class="custom_dropdown custom_dropdown_b my-1"
          @show="activate_custom_backdrop"
          @hidden="deactivate_custom_backdrop"
          variant="info"
          :text="oa_filter1"
          title="Operating Area"
        >
          <b-dropdown-item @click="oaFilter1('All Operating Areas', 0)">All Operating Areas</b-dropdown-item>
          <b-dropdown-item
            @click="oaFilter1(operating_area_filter.name, operating_area_filter.id)"
            v-for="operating_area_filter in operating_areas_filter1"
          >{{operating_area_filter.name}}</b-dropdown-item>
        </b-dropdown>
      </b-col>
      <b-col md="1">
        <b-btn @click="clearFilters1()" class="pull-right pull-sm-left my-1" variant="info">Clear</b-btn>
      </b-col>
      <b-col>
        <b-btn
          class="pull-right my-1"
          v-b-popover.hover.top="'Activate/Deactivate bbl'"
          variant="info"
          @click="bbl()"
        >
          <i class="fa fa-bullseye"></i>
        </b-btn>
         <b-btn v-if="role =='super_admin'" 
                class="pull-right my-1" 
                @click="activate_chart_click()"  
                v-b-popover.hover.top="'Activate/Deactivate Chart'" 
                variant="info"><i class="fa fa-bar-chart"></i></b-btn>
         <b-btn v-if="role =='super_admin' && chart_activated && (load_locations_id.length > 0 || unload_locations_id.length > 0)" class="pull-right my-1" @click="generate_chart_click()" variant="info">Generate Chart</b-btn>
      </b-col>

    </b-row>
    <!-- Graph 0 margin-bottom: 0; line-height: 17px;-->
    <b-row>
      <b-col sm="6" lg="6">
        <b-card no-body class="bg-targets cart-100">
          <b-card-body class="pb-0">
            <h4 style="line-height: 20px; margin-bottom: 5px;">Alerts</h4>
            <p
              style="margin-bottom: 0; line-height: 17px;"
            >{{alerts.initial_date}}-{{alerts.end_date}}</p>
            <br />
            <p style="margin-bottom: 0; line-height: 17px;"></p>
            <p
              onmouseover="this.style.cursor='pointer'"
              v-on:click="alert_filter('Volume > 60 m³')"
              style="margin-bottom: 0; line-height: 17px;"
            >Volume Spikes : {{alerts.spike}} Loads</p>
            <br />
            <p
              onmouseover="this.style.cursor='pointer'"
              v-on:click="alert_filter('BS&W - 100%')"
              style="margin-bottom: 0; line-height: 17px;"
            >BS&W=100% : {{alerts.b100}} Loads</p>
            <br />
            <p
              onmouseover="this.style.cursor='pointer'"
              v-on:click="alert_filter('BS&W < 0.5%')"
              style="margin-bottom: 0; line-height: 17px;"
            >BS&W<0.5% : {{alerts.b50}} Loads</p>
            <br />
            <p
              onmouseover="this.style.cursor='pointer'"
              v-on:click="alert_filter('BS&W - Additional Fees Apply')"
              style="margin-bottom: 0; line-height: 17px;"
            >Additional Fees: {{alerts.fee}} Loads</p>
            <br />
            <p
              onmouseover="this.style.cursor='pointer'"
              v-on:click="alert_filter('Haul without Nom')"
              style="margin-bottom: 0; line-height: 17px;"
            >Hauls w/o Nominations: {{alerts.nom}} Loads</p>
            <br />
          </b-card-body>
          <br />
          <br />
          <br />
        </b-card>
      </b-col>
      <b-col v-if="!chart_activated" sm="6" lg="6" v-for="target_chart in targets_chart">
        <b-card no-body class="bg-targets cart-100">
          <b-container>
            <b-row>
              <b-col class="col-auto">
                <h4
                  style="line-height: 20px; margin-bottom: 5px;margin-top: 5px; font-weight: bold"
                >{{target_chart.target_data.legal_location}}</h4>
                <p
                  style="margin-bottom: 0; line-height: 17px;"
                >{{target_chart.target_data.target_initial_date}}-{{target_chart.target_data.target_end_date}}</p>
                <p
                  style="margin-bottom: 0; line-height: 17px;"
                >{{target_chart.target_data.fluid_name}}</p>
              </b-col>
              <b-col>
                <h4
                  onmouseover="this.style.cursor='pointer'"
                  v-on:click="est_detail(target_chart.target_data.estimate_selling_price)"
                  style="line-height: 20px; margin-bottom: 5px; margin-top: 5px;text-align: right"
                >{{target_chart.target_data.estimate_selling_price.price}}</h4>
                <!-- </b-card-body> -->
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <highcharts :options="target_chart.target_chart"></highcharts>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <highcharts class="chart" :options="target_chart.target_chart1"></highcharts>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </b-col>
      <b-col v-if="location_other.length !=0 && !chart_activated" sm="6" lg="4">
        <b-card no-body class="bg-targets cart-100">
          <b-container>
            <b-row align-h="center">
              <b-col md="12">
                <!-- <b-card-body class="pb-0"> class="justify-content-md-center" -->
                <h4
                  style="line-height: 20px; margin-bottom: 5px;margin-top: 5px;"
                >{{location_other[0].location_data.legal_location}}</h4>
                <p
                  style="margin-bottom: 0; line-height: 17px;"
                >{{location_other[0].location_data.location_initial_date}}-{{location_other[0].location_data.location_end_date}}</p>
                <!-- </b-card-body> -->
              </b-col>
              <!-- <b-col md="6">
              <b-card-body class="pb-0">
                <h4 style="line-height: 20px; margin-bottom: 5px; text-align: right">{{location_other[0].location_data.estimate_selling_price}}</h4>
              </b-card-body>
              </b-col>-->
              <highcharts class="chart" :options="location_other[0].target_chart"></highcharts>
            </b-row>
          </b-container>
        </b-card>
      </b-col>
    </b-row>
    <!-- Test Graph  - Volume by Date    -->
    <b-row  v-if="role =='super_admin' &&  chart_activated && (unloadlocationselect.length > 0 || loadlocationselect.length > 0)">
      <b-col sm="4" lg="4">	
        <b-row >
          <b-col>			
			      <b-form-group v-if="loadlocationselect.length > 0" label-size='lg' label-class="font-weight-bold pt-0" id="L5" label="Load Locations" label-for="loadLocationsID" vertical>
				        <b-form-checkbox-group value-field="id" text-field="legal_location"  class="custom-checkboxes" :options="loadlocationselect" name="Checkboxes2" plain v-model="load_locations_id" @input="loadLocationsChange"></b-form-checkbox-group>
				          <b-form-checkbox style="margin-top: 15px;" v-model="llAllSelected" :indeterminate="indeterminateLL" aria-describedby="" aria-controls="" plain @change="LLToggleAll">
					            {{ llAllSelected ? 'Un-select All' : 'Select All' }}
				          </b-form-checkbox>
			      </b-form-group>
            <span v-else>No Load locations</span>
          </b-col> 
        </b-row> 
        <b-row>
          <b-col>
			      <b-form-group v-if="unloadlocationselect.length > 0" label-size='lg' label-class="font-weight-bold pt-0" id="L6" label="Unload Locations" label-for="unloadLocationsID" vertical>
				      <b-form-checkbox-group value-field="id" text-field="legal_location" class="custom-checkboxes" :options="unloadlocationselect" name="Checkboxes2" plain v-model="unload_locations_id" @input="unloadLocationsChange"></b-form-checkbox-group>
				        <b-form-checkbox style="margin-top: 15px;" v-model="ulAllSelected" :indeterminate="indeterminateUL" aria-describedby="" aria-controls="" plain @change="ULToggleAll">
					        {{ ulAllSelected ? 'Un-select All' : 'Select All' }}
				        </b-form-checkbox>
			      </b-form-group>
            <span v-else>No Unload locations</span>
          </b-col> 
        </b-row>    
      </b-col>
      <b-col sm="8" lg="8">
        <b-card no-body class="chart-wrapper" bg-variant="light">
          <b-container>
            <b-row>
              <b-col>
                <highcharts class="chart" :options="chart"></highcharts>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </b-col>
    </b-row>
        <!-- Test Graph  - Volume by Date User-->
    <b-row v-if="role =='super_admin' &&  chart_activated && users_select.length >0 && (load_locations_id.length > 0 || unload_locations_id.length > 0)">
      <b-col sm="4" lg="4">	
        <b-row >
          <b-col>		
			      <b-form-group v-if="users_select.length > 0" label-size='lg' label-class="font-weight-bold pt-0" id="L7" label="Drivers" label-for="userID" vertical>
				      <b-form-checkbox-group value-field="id" text-field="name"  class="custom-checkboxes" :options="users_select" name="Checkboxes2" plain v-model="users_id" @input="user_Change"></b-form-checkbox-group>
				          <b-form-checkbox style="margin-top: 15px;" v-model="user_AllSelected" :indeterminate="indeterminate_user" aria-describedby="" aria-controls="" plain @change="user_ToggleAll">
					          {{ user_AllSelected ? 'Un-select All' : 'Select All' }}
				      </b-form-checkbox>
			      </b-form-group>       
            <p v-else>No Users</p>
          </b-col>
        </b-row>    
      </b-col>
      <b-col sm="8" lg="8">
        <b-card no-body class="chart-wrapper" bg-variant="light">
          <b-container>
            <b-row>
              <b-col>
                <highcharts class="chart" :options="chart_users"></highcharts>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </b-col>
    </b-row>
    <!-- First Graph - Fluid by Terminal-->
    <draggable
      :list="list"
      :disabled="!enabled"
      ghost-class="ghost"
      @start="dragging = true"
      @end="change"
      v-if="!chart_activated"
    >
      <b-row v-for="element in list" :key="element.chart">
        <b-col sm="1" lg="1">
          <b-card no-body class="drag chart" style></b-card>
        </b-col>
        <b-col sm="11" lg="11">
          <b-card no-body class style>
            <highcharts c :options="$eval('this.'+element.chart)"></highcharts>
          </b-card>
        </b-col>
      </b-row>
    </draggable>
    <b-modal title v-model="calculate" hide-header-close no-close-on-backdrop no-close-on-esc>
      <p>{{show_formula}}</p>
      <b-row>
        <b-table
          borderless
          show-empty
          empty-text="No Variables added"
          :fields="[{key: 'chk', label: 'Added'}, {key: 'variable_name', label: 'Variable'}, {key: 'variable_value', label: 'Value'}]"
          :items="estimate_selling_price"
          stacked="sm"
          small
        >
          <template slot="chk" slot-scope="row">
            <b-form-checkbox
              id="checkbox"
              v-model="row.item.chk"
              size="sm"
              @change="checkedField(row.item.variable_name, row.index, row.item.chk)"
            ></b-form-checkbox>
          </template>
          <template slot="variable_value" slot-scope="row">
            <b-form v-if="row.item.chk">
              <b-form-select
                v-if="row.item.variable_name=='BBL to m3:'"
                value-field="id"
                text-field="name"
                id="id_51"
                v-model="row.item.variable_value"
                :options="bbl_array"
              >
                <template slot="first">
                  <option :value="null" disabled>-- select bbl --</option>
                </template>
              </b-form-select>
              <b-form-input
                v-else
                plaintext
                id="id_1"
                v-model="row.item.variable_value"
                type="text"
              ></b-form-input>
            </b-form>
          </template>
        </b-table>
      </b-row>
      <div slot="modal-footer" class="w-100">
        <b-btn size="md" variant="secondary" @click="calculate=false" class="float-left">Cancel</b-btn>
        <b-btn size="md" variant="primary" @click="save_formula()" class="float-right">Save</b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import CardBarChartTarget from "./dashboard/CardBarChartTarget";
import dashboard_service from "./dashboard/dashboard_service";
import { Chart } from "highcharts-vue";
import users_service from "./users/users_service";
import draggable from "vuedraggable";
export default {
  created: function() {
    if (
      localStorage.getItem("role") == "super_admin" ||
      localStorage.getItem("role") == "super_analyst" ||
      localStorage.getItem("role") == "analyst" ||
      localStorage.getItem("role") == "marketing_accountant" ||
      localStorage.getItem("role") == "operations_manager"
    ) {
      this.getChartConfigs();
      this.getDashboard();
      this.getAlerts();
      this.getAvgDailyDistance();
      this.getWaitTimeChart();
      // this.getTargetChart();
      this.getAvgMinuteLoadChart();
      this.getFluidByLoadChart();
      this.getFluidByUnloadChart();
      this.getTargetList();
      this.dash_filter()

    } else if (localStorage.getItem("role") == "trucking_company_admin") {
      this.getAlerts();
    }
  },
  data() {
    return {
      enabled: true,
      list: [],
      dragging: false,
      //
      //  chartData: null,
      alerts: {},
      targets: [],
      targets_chart: [],
      targets_chart1: [],
      location_other: [],
      head_text: [],
      updateArgs: "",
      wait_time_chart: {},
      avg_daily_distance_chart: {},
      avg_minute_load_chart: {},
      fluid_by_unload_chart: {},
      fluid_by_load_chart: {},
      loadingData: true,
      // ec_filter: "All Energy Companies",
      h: 85,
      dataCharts: [],
      optionsChart: {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              display: false,
              categoryPercentage: 1,
              barPercentage: 0.5
            }
          ],
          yAxes: [
            {
              display: false
            }
          ]
        }
      },
      optionsChartB: {},
      optionsChartBB: {},
      role: "",
      view: true,
      energy_company_id: 1,
      calculate: false,
      model: {
        wti: "",
        index: "",
        forex: "",
        wadf: "",
        bbl: "",
        avg_haul_cost: "",
        terminal_cost: ""
      },
      // ajuste en Dashboard
      estimate_selling_price: [],
      save_selling_price: {
        location_id: 0,
        price: "0.00",
        variables: [],
        initial_date: "",
        end_date: ""
      },
      bbl_array: [
        { id: 1, name: "Heavy BBL to m3 6.289800" },
        { id: 2, name: "Light BBL to m3 6.7" }
      ],
      show_formula:
        "Selling Price(estimated) = ({({ WTI Last Price + Index } * Forex * BBL to m3 ) + WADF } - Avg Haul Cost)- Terminal Cost",
      chart                 : {
        'chart' : { 'backgroundColor' : '#37393F',
                      'height'          : 600
                  }
      },
      loadlocationselect    : [],
      unloadlocationselect  : [],
      indeterminateLL       : false,
			llAllSelected         : false,
			indeterminateUL       : false,
			indeterminate         : false,
      ulAllSelected         : false,
      load_locations_id     : [],
      unload_locations_id   : [],
      users_select          : [],
      users_id              : [],
      indeterminate_user    : false,
      user_AllSelected      : false,
      chart_users           : {
          'chart' : { 'backgroundColor' : '#37393F',
                      'height'          : 600
                  }
      },
      chart_activated           : false,
      energy_companies_filter   : [],
      operating_areas_filter    : [],
      trucking_companies_filter : [],
      ec_filter                 : "",
      tc_filter                 : "All Trucking Companies",
      oa_filter                 : "All Operating Areas",
      filter_by: {
        energy_company_id   : 1,
        trucking_company_id : "",
        initial_date        : moment()
          .startOf("month")
          .format("YYYY-MM-DD"),
        end_date            : moment()
          .endOf("month")
          .format("YYYY-MM-DD"),
        operating_area_id   : "",       
      },
      energy_companies_filter1   : [],
      operating_areas_filter1    : [],
      trucking_companies_filter1 : [],
      ec_filter1                 : "All Energy Companies",
      tc_filter1                 : "All Trucking Companies",
      oa_filter1                 : "All Operating Areas",
      filter_by1: {
        energy_company_id   : "",
        trucking_company_id : "",
        initial_date        : moment()
          .startOf("month")
          .format("YYYY-MM-DD"),
        end_date            : moment()
          .endOf("month")
          .format("YYYY-MM-DD"),
        operating_area_id   : "",
        users               : [], 
        load_locations      : [],
        unload_locations    : [],        
      },
      company                : "Energy Companies"
    };
  },
  name: "charts",
  name: "dashboard",
  beforeCreate: function() {
    if (!localStorage.getItem("access_token")) {
      this.$router.replace("/login");
    }
    if (localStorage.getItem("role") == "trucking_company_admin") {
      this.$router.replace("/dash/");
    }
    if (localStorage.getItem("role") == "trucking_company_admin_light") {
      this.$router.replace("/users/");
    }
  },
  components: {
    CardBarChartTarget,
    highcharts: Chart,
    draggable
  },
  computed: {
    draggingInfo() {
      return this.dragging ? "under drag" : "";
    }
  },
  methods: {
    getTargetIter(id) {
      let app = this;
      dashboard_service
        .getTargetIter(this.filter_by, id)
        .then(data => {
          if (data.status == "success" && data.targets_chart.length>0) {
            // Target Chart
            // this.targets_chart = data.targets_chart;
            this.targets_chart.push(data.targets_chart[0]);
            if (this.targets_chart.length != 0) {
              this.targets_chart.forEach(function(target) {
                target.target_chart.chart.width = null;
                target.target_chart.chart.height = 280;
                target.target_chart.chart.margin = [9, 5, 60, 0];
                target.target_chart.yAxis[0]["max"] = null;
                target.target_chart.yAxis[0]["lineWidth"] = 0;
                target.target_chart.xAxis[0]["lineWidth"] = 1;

                target.target_chart.xAxis[0].labels = {
                  enabled: true,
                  formatter: function() {
                    return moment(this.value).format("MMM-DD");
                  },
                  autoRotation: [-90],
                  style: {
                    color: "#FFF",
                    fontSize: "10px"
                  }
                };

                target.target_chart1.series[0].dataLabels.style = {
                  color: "white",
                  textOutline: false,
                  fontSize: "14px"
                };
                target.target_chart1.series[1].dataLabels.style = {
                  color: "white",
                  textOutline: false,
                  fontSize: "14px"
                };
                target.target_chart.plotOptions.series.point.events.click = function() {
                  var filters = this.options.key;
                  var filters_sep = filters.split("?");
                  localStorage.setItem("dashboard", "dash04");
                  localStorage.setItem(
                    "dashboard_start_date",
                    moment(this.category).format("YYYY-MM-DD")
                  );
                  localStorage.setItem(
                    "dashboard_end_date",
                    moment(this.category).format("YYYY-MM-DD")
                  );
                  localStorage.setItem("dashboard_energy_id", filters_sep[0]);
                  localStorage.setItem("dashboard_energy_name", filters_sep[1]);
                  localStorage.setItem("dashboard_location_id", filters_sep[2]);
                  localStorage.setItem(
                    "dashboard_location_name",
                    filters_sep[3]
                  );
                  localStorage.setItem(
                    "dashboard_fluid_type_id",
                    filters_sep[4]
                  );
                  localStorage.setItem(
                    "dashboard_fluid_type_name",
                    filters_sep[5]
                  );
                  localStorage.setItem(
                    "dashboard_trucking_company_id",
                    filters_sep[6]
                  );
                  localStorage.setItem(
                    "dashboard_trucking_company_name",
                    filters_sep[7]
                  );
                  var currentUrl =
                    "http://" + window.location.host + "/#/hauls";
                  window.location.href = currentUrl;
                  return;
                };
              });
            }
          }
        })
        .catch(error => {
          this.$swal("Error", "Server not response. " + error, "error");
          this.loadingData = false;
        });
    },
    getTargetList() {
      let app = this;
      dashboard_service
        .getTargetList(this.filter_by)
        .then(data => {
          if (data.status == "success") {
            this.targets = data.targets
            this.targets_chart = []
            this.targets.map((item) => {
                   this.getTargetIter(item.id)
                    })
            
          }
        })
        .catch(error => {
          this.$swal("Error", "Server not response. " + error, "error");
          this.loadingData = false;
        });
    },
    getAlerts() {
      let app = this;
      dashboard_service
        .getAlerts(this.filter_by)
        .then(data => {
          if (data.status == "success") {
            this.alerts = data.alerts;
          }
        })
        .catch(error => {
          this.$swal("Error", "Server not response. " + error, "error");
          this.loadingData = false;
        });
    },
    getFluidByUnloadChart() {
      let app = this;
      dashboard_service
        .getFluidByUnloadChart(this.filter_by)
        .then(data => {
          if (data.status == "success") {
            // Fluid by Unload Location Chart
            this.fluid_by_unload_chart = data.fluid_by_unload_chart;
            localStorage.setItem(
              "dashboard_start_date",
              this.fluid_by_unload_chart.plotOptions.series.point.events.click
            );
            localStorage.setItem(
              "dashboard_end_date",
              this.fluid_by_unload_chart.plotOptions.series.point.description
            );
            this.fluid_by_unload_chart.plotOptions.series.point.description = undefined;
            this.fluid_by_unload_chart.plotOptions.series.point.events.click = function() {
              var filters = this.options.key;
              var filters_sep = filters.split("?");
              localStorage.setItem("dashboard", "dash06");
              localStorage.setItem("dashboard_energy_id", filters_sep[0]);
              localStorage.setItem("dashboard_energy_name", filters_sep[1]);
              localStorage.setItem("dashboard_location_id", filters_sep[2]);
              localStorage.setItem("dashboard_location_name", filters_sep[3]);
              localStorage.setItem("dashboard_fluid_type_id", filters_sep[4]);
              localStorage.setItem("dashboard_fluid_type_name", filters_sep[5]);
              localStorage.setItem(
                "dashboard_trucking_company_id",
                filters_sep[6]
              );
              localStorage.setItem(
                "dashboard_trucking_company_name",
                filters_sep[7]
              );
              var currentUrl = "http://" + window.location.host + "/#/hauls";
              window.location.href = currentUrl;
              return;
            };
            this.fluid_by_unload_chart.tooltip.formatter = function() {
              var location = this.series.name;
              var min = this.series.options.stack;
              var percentage = " (" + this.point.percentage.toFixed(1) + "%)";
              return (
                "<b>" +
                this.x +
                "</b><br/>" +
                location +
                ": " +
                this.y +
                min +
                percentage +
                "<br/>" +
                " Total Column: " +
                this.point.stackTotal +
                min
              );
            };
          }
        })
        .catch(error => {
          this.$swal("Error", "Server not response. " + error, "error");
          this.loadingData = false;
        });
    },
    getFluidByLoadChart() {
      let app = this;
      dashboard_service
        .getFluidByLoadChart(this.filter_by)
        .then(data => {
          if (data.status == "success") {
            // Fluid by Load Location Chart
            this.fluid_by_load_chart = data.fluid_by_load_chart;
            localStorage.setItem(
              "dashboard_start_date",
              this.fluid_by_load_chart.plotOptions.series.point.events.click
            );
            localStorage.setItem(
              "dashboard_end_date",
              this.fluid_by_load_chart.plotOptions.series.point.description
            );
            this.fluid_by_load_chart.plotOptions.series.point.description = undefined;
            this.fluid_by_load_chart.plotOptions.series.point.events.click = function() {
              var filters = this.options.key;
              var filters_sep = filters.split("?");
              localStorage.setItem("dashboard", "dash05");
              localStorage.setItem("dashboard_energy_id", filters_sep[0]);
              localStorage.setItem("dashboard_energy_name", filters_sep[1]);
              localStorage.setItem("dashboard_location_id", filters_sep[2]);
              localStorage.setItem("dashboard_location_name", filters_sep[3]);
              localStorage.setItem("dashboard_fluid_type_id", filters_sep[4]);
              localStorage.setItem("dashboard_fluid_type_name", filters_sep[5]);
              localStorage.setItem(
                "dashboard_trucking_company_id",
                filters_sep[6]
              );
              localStorage.setItem(
                "dashboard_trucking_company_name",
                filters_sep[7]
              );
              var currentUrl = "http://" + window.location.host + "/#/hauls";
              window.location.href = currentUrl;
              return;
            };
            this.fluid_by_load_chart.tooltip.formatter = function() {
              var location = this.series.name;
              var min = this.series.options.stack;
              var percentage = " (" + this.point.percentage.toFixed(1) + "%)";
              return (
                "<b>" +
                this.x +
                "</b><br/>" +
                location +
                ": " +
                this.y +
                min +
                percentage +
                "<br/>" +
                " Total Column: " +
                this.point.stackTotal +
                min
              );
            };
          }
        })
        .catch(error => {
          this.$swal("Error", "Server not response. " + error, "error");
          this.loadingData = false;
        });
    },
    getAvgMinuteLoadChart() {
      let app = this;
      dashboard_service
        .getAvgMinuteLoadChart(this.filter_by)
        .then(data => {
          if (data.status == "success") {
            // Wait time Average Chart
            this.avg_minute_load_chart = data.avg_minute_load_chart;
            var filters = this.avg_minute_load_chart.plotOptions.series.point
              .events.click;
            this.avg_minute_load_chart.plotOptions.series.point.events.click = function() {
              var filters = this.options.key;
              var filters_sep = filters.split("?");
              localStorage.setItem("dashboard", "dash03");
              localStorage.setItem("dashboard_energy_id", filters_sep[0]);
              localStorage.setItem("dashboard_energy_name", filters_sep[1]);
              localStorage.setItem("dashboard_location_id", filters_sep[2]);
              localStorage.setItem("dashboard_location_name", filters_sep[3]);
              localStorage.setItem(
                "dashboard_trucking_company_id",
                filters_sep[4]
              );
              localStorage.setItem(
                "dashboard_trucking_company_name",
                filters_sep[5]
              );
              localStorage.setItem(
                "dashboard_start_date",
                moment(this.category).format("YYYY-MM-DD")
              );
              localStorage.setItem(
                "dashboard_end_date",
                moment(this.category).format("YYYY-MM-DD")
              );
              var currentUrl = "http://" + window.location.host + "/#/hauls";
              window.location.href = currentUrl;
              return;
            };
            this.avg_minute_load_chart.tooltip.formatter = function() {
              var location = this.series.name;
              var stack = this.series.options.stack;
              var min = " min";
              var percentage = " (" + this.point.percentage.toFixed(1) + "%)";
              if (stack.indexOf("Total") == 0) {
                stack = "Total";
              } else if (stack.indexOf("Oil") == 0) {
                stack = "Oil";
              } else if (stack.indexOf("Water") == 0) {
                stack = "Water";
              } else if (stack.indexOf("Load") == 0) {
                stack = "Load";
              } else if (stack.indexOf("Unload") == 0) {
                stack = "Unload";
              } else if (stack.indexOf(" Load/Unload") == 0) {
                stack = "Load/Unload";
                min = " ";
                percentage = " ";
              }

              if (this.series.name.indexOf("Total") == 0) {
                location = this.series.options.stack.substring(
                  5,
                  this.series.options.stack.length
                );
                stack = "Total";
              } else if (this.series.name.indexOf("Oil") == 0) {
                location = this.series.options.stack.substring(
                  3,
                  this.series.options.stack.length
                );
                stack = "Oil";
              } else if (this.series.name.indexOf("Water") == 0) {
                location = this.series.options.stack.substring(
                  5,
                  this.series.options.stack.length
                );
                stack = "Water";
              } else if (this.series.name.indexOf("Load") == 0) {
                location = this.series.options.stack.substring(
                  4,
                  this.series.options.stack.length
                );
                stack = "Load";
              } else if (this.series.name.indexOf("Unload") == 0) {
                location = this.series.options.stack.substring(
                  6,
                  this.series.options.stack.length
                );
                stack = "Unload";
              } else if (this.series.name.indexOf(" Load/Unload") == 0) {
                location = this.series.options.stack.substring(
                  12,
                  this.series.options.stack.length
                );
                stack = "Load/Unload";
              }
              //this.series.name.substring(n, this.series.name.length-l)
              return (
                "<b>" +
                this.x +
                "</b><br/>" +
                stack +
                "<br/>" +
                location +
                ": " +
                this.y +
                min +
                percentage +
                "<br/>" +
                " Total Column: " +
                this.point.stackTotal +
                min
              );
            };
          }
        })
        .catch(error => {
          this.$swal("Error", "Server not response. " + error, "error");
          this.loadingData = false;
        });
    },
    getTargetChart() {
      let app = this;
      dashboard_service
        .getTargetChart(this.filter_by)
        .then(data => {
          if (data.status == "success") {
            // Target Chart
            this.targets_chart = data.targets_chart;
            if (this.targets_chart.length != 0) {
              this.targets_chart.forEach(function(target) {
                target.target_chart.chart.width = null;
                target.target_chart.chart.height = 280;
                target.target_chart.chart.margin = [9, 5, 60, 0];
                target.target_chart.yAxis[0]["max"] = null;
                target.target_chart.yAxis[0]["lineWidth"] = 0;
                target.target_chart.xAxis[0]["lineWidth"] = 1;

                target.target_chart.xAxis[0].labels = {
                  enabled: true,
                  formatter: function() {
                    return moment(this.value).format("MMM-DD");
                  },
                  autoRotation: [-90],
                  style: {
                    color: "#FFF",
                    fontSize: "10px"
                  }
                };

                target.target_chart1.series[0].dataLabels.style = {
                  color: "white",
                  textOutline: false,
                  fontSize: "14px"
                };
                target.target_chart1.series[1].dataLabels.style = {
                  color: "white",
                  textOutline: false,
                  fontSize: "14px"
                };
                target.target_chart.plotOptions.series.point.events.click = function() {
                  var filters = this.options.key;
                  var filters_sep = filters.split("?");
                  localStorage.setItem("dashboard", "dash04");
                  localStorage.setItem(
                    "dashboard_start_date",
                    moment(this.category).format("YYYY-MM-DD")
                  );
                  localStorage.setItem(
                    "dashboard_end_date",
                    moment(this.category).format("YYYY-MM-DD")
                  );
                  localStorage.setItem("dashboard_energy_id", filters_sep[0]);
                  localStorage.setItem("dashboard_energy_name", filters_sep[1]);
                  localStorage.setItem("dashboard_location_id", filters_sep[2]);
                  localStorage.setItem(
                    "dashboard_location_name",
                    filters_sep[3]
                  );
                  localStorage.setItem(
                    "dashboard_fluid_type_id",
                    filters_sep[4]
                  );
                  localStorage.setItem(
                    "dashboard_fluid_type_name",
                    filters_sep[5]
                  );
                  localStorage.setItem(
                    "dashboard_trucking_company_id",
                    filters_sep[6]
                  );
                  localStorage.setItem(
                    "dashboard_trucking_company_name",
                    filters_sep[7]
                  );
                  var currentUrl =
                    "http://" + window.location.host + "/#/hauls";
                  window.location.href = currentUrl;
                  return;
                };
              });
            }
          }
        })
        .catch(error => {
          this.$swal("Error", "Server not response. " + error, "error");
          this.loadingData = false;
        });
    },
    getAvgDailyDistance() {
      let app = this;
      dashboard_service
        .getAvgDailyDistance(this.filter_by)
        .then(data => {
          if (data.status == "success") {
            //  data.avg_daily_distance_chart.series.forEach(function(value) {
            //   if (!value.data) {
            //     data.avg_daily_distance_chart.series = [];
            //     data.wait_time_chart.series = [];
            //     data.avg_minute_load_chart.series = [];
            //   }
            // });

            // Dayly Distance Chart
            this.avg_daily_distance_chart = data.avg_daily_distance_chart;
            this.avg_daily_distance_chart.plotOptions.series.point.events.click = function() {
              var filters = this.options.key;
              var filters_sep = filters.split("?");
              localStorage.setItem("dashboard", "dash01");
              localStorage.setItem(
                "dashboard_start_date",
                moment(this.category).format("YYYY-MM-DD")
              );
              localStorage.setItem(
                "dashboard_end_date",
                moment(this.category).format("YYYY-MM-DD")
              );
              localStorage.setItem("dashboard_energy_id", filters_sep[0]);
              localStorage.setItem("dashboard_energy_name", filters_sep[1]);
              localStorage.setItem(
                "dashboard_trucking_company_id",
                filters_sep[2]
              );
              localStorage.setItem(
                "dashboard_trucking_company_name",
                filters_sep[3]
              );
              var currentUrl = "http://" + window.location.host + "/#/hauls";
              window.location.href = currentUrl;
              return;
            };
          }
        })
        .catch(error => {
          this.$swal("Error", "Server not response. " + error, "error");
          this.loadingData = false;
        });
    },
    getWaitTimeChart() {
      let app = this;
      dashboard_service
        .getWaitTimeChart(this.filter_by)
        .then(data => {
          if (data.status == "success") {
            // Wait time Chart
            this.wait_time_chart = data.wait_time_chart;
            this.wait_time_chart.plotOptions.series.point.events.click = function() {
              var filters = this.options.key;
              var filters_sep = filters.split("?");
              localStorage.setItem("dashboard", "dash02");
              localStorage.setItem(
                "dashboard_start_date",
                moment(this.category).format("YYYY-MM-DD")
              );
              localStorage.setItem(
                "dashboard_end_date",
                moment(this.category)
                  .add(6, "days")
                  .format("YYYY-MM-DD")
              );
              localStorage.setItem("dashboard_energy_id", filters_sep[0]);
              localStorage.setItem("dashboard_energy_name", filters_sep[1]);
              localStorage.setItem(
                "dashboard_trucking_company_id",
                filters_sep[2]
              );
              localStorage.setItem(
                "dashboard_trucking_company_name",
                filters_sep[3]
              );
              var currentUrl = "http://" + window.location.host + "/#/hauls";
              window.location.href = currentUrl;
              return;
            };
          }
        })
        .catch(error => {
          this.$swal("Error", "Server not response. " + error, "error");
          this.loadingData = false;
        });
    },
    getDashboard() {
      let app = this;
      dashboard_service
        .getDashboard(this.filter_by)
        .then(data => {
          if (data.status == "success") {
            // Location Other Chart
            this.location_other = data.location_other;

            if (this.location_other.length != 0) {
              this.location_other.forEach(function(other) {
                other.target_chart.plotOptions.series.point.events.click = function() {
                  var filters = this.options.key;
                  var filters_sep = filters.split("?");
                  localStorage.setItem("dashboard", "dash07");
                  localStorage.setItem(
                    "dashboard_start_date",
                    moment(this.category).format("YYYY-MM-DD")
                  );
                  localStorage.setItem(
                    "dashboard_end_date",
                    moment(this.category).format("YYYY-MM-DD")
                  );
                  localStorage.setItem("dashboard_energy_id", filters_sep[0]);
                  localStorage.setItem("dashboard_energy_name", filters_sep[1]);
                  localStorage.setItem("dashboard_location_id", filters_sep[2]);
                  localStorage.setItem(
                    "dashboard_location_name",
                    filters_sep[3]
                  );
                  localStorage.setItem(
                    "dashboard_fluid_type_id",
                    filters_sep[4]
                  );
                  localStorage.setItem(
                    "dashboard_fluid_type_name",
                    filters_sep[5]
                  );
                  localStorage.setItem(
                    "dashboard_trucking_company_id",
                    filters_sep[6]
                  );
                  localStorage.setItem(
                    "dashboard_trucking_company_name",
                    filters_sep[7]
                  );
                  var currentUrl =
                    "http://" + window.location.host + "/#/hauls";
                  window.location.href = currentUrl;
                  return;
                };
              });
            }

            
            
            let monthNames = [
              " Jan. ",
              " Feb. ",
              " Mar. ",
              " Apr. ",
              " May. ",
              " Jun. ",
              " Jul. ",
              " Aug. ",
              " Sep. ",
              " Oct. ",
              " Nov. ",
              " Dec. "
            ];
            this.energy_companies_filter = data.energy_companies_filter;
            //this.trucking_companies_filter = data.trucking_companies_filter;
            this.energy_companies_filter.forEach(function(value) {
              if (app.filter_by["energy_company_id"] === value.id) {
                app.ec_filter = value.company_name;
              } else {
                localStorage.setItem("temp_energy_company_id", value.id);
                localStorage.setItem(
                  "temp_energy_company_name",
                  value.company_name
                );
              }
            });
            if (this.ec_filter == "") {
              this.ec_filter = localStorage.getItem("temp_energy_company_name");
              this.filter_by["energy_company_id"] = localStorage.getItem(
                "temp_energy_company_id"
              );
            }
            if ("temp_energy_company_id" in localStorage) {
              localStorage.removeItem("temp_energy_company_id");
            }
            if ("temp_energy_company_name" in localStorage) {
              localStorage.removeItem("temp_energy_company_name");
            }
            this.role = data.role;
            if (this.role == "super_admin") {
              this.view = true;
            } else {
              this.view = false;
              this.filter_by[
                "energy_company_id"
              ] = this.energy_companies_filter[0].id;
            }
            let pos = this.energy_companies_filter
              .map(o => o.id)
              .indexOf(this.filter_by["energy_company_id"]);
            if (pos > -1) {
                this.operating_areas_filter     = this.energy_companies_filter[pos].operating_areas;
                this.trucking_companies_filter  = this.energy_companies_filter[pos].trucking_companies;
            } else {
                this.operating_areas_filter     = []
                this.trucking_companies_filter  = []
            }
            this.loadingData = false;
          } else {
            this.$swal(data.status, data.message, data.status);
            this.loadingData = false;
            // this.getAll()
            return;
          }
        })
        .catch(error => {
          this.$swal("Error", "Server not response. " + error, "error");
          this.loadingData = false;
        });
    },
    $eval(expr, obj) {
      var item = obj;
      return eval(expr);
    },
    change() {
      dashboard_service.putChartConfigs(this.list).then(data => {
        this.getChartConfigs();
      });
    },
    activate_custom_backdrop() {
      this.$root.$el.classList.add("custom_backdrop_behavior");
    },
    deactivate_custom_backdrop() {
      this.$root.$el.classList.remove("custom_backdrop_behavior");
    },
    bbl() {
      let app = this;
      users_service.bbl().then(data => {
        if (data[0] == "success") {
          app.getDashboard();
          app.getAlerts();
        } else {
          Vue.swal(data[0], data[1], data[0]);
        }
      });
    },
    iFilter() {
      if (this.filter_by["end_date"] == "" || !this.filter_by["end_date"]) {
        this.filter_by["end_date"] = "";
      }
      this.getDashboard();
      this.getAlerts();
      this.getAvgDailyDistance();
      this.getWaitTimeChart();
      // this.getTargetChart();
      this.getAvgMinuteLoadChart();
      this.getFluidByLoadChart();
      this.getFluidByUnloadChart();
      this.getTargetList();
      this.loadingData = true;
    },
    eFilter() {
      if (
        this.filter_by["initial_date"] == "" ||
        !this.filter_by["initial_date"]
      ) {
        this.filter_by["initial_date"] = "";
      }
      this.getDashboard();
      this.getAlerts();
      this.getAvgDailyDistance();
      this.getWaitTimeChart();
      // this.getTargetChart();
      this.getAvgMinuteLoadChart();
      this.getFluidByLoadChart();
      this.getFluidByUnloadChart();
      this.getTargetList();
      
      this.loadingData = true;
    },
    clearFilters() {
      this.ec_filter = "";
      this.filter_by = {
        energy_company_id: 1,
        trucking_company_id: "",
        initial_date: moment()
          .startOf("month")
          .format("YYYY-MM-DD"),
        end_date: moment()
          .endOf("month")
          .format("YYYY-MM-DD"),
        operating_area_id: ""
      };
      this.loadingData = true;
      this.getDashboard();
      this.getAlerts();
      this.getAvgDailyDistance();
      this.getWaitTimeChart();
      // this.getTargetChart();
      this.getAvgMinuteLoadChart();
      this.getFluidByLoadChart();
      this.getFluidByUnloadChart();
      this.getTargetList();
      
    },
    ecFilter(ec_filter, id) {
      this.ec_filter = ec_filter;
      this.filter_by["energy_company_id"] = id;
      this.oa_filter = "All Operating Areas";
      this.loadingData = true;
      this.getDashboard();
      this.getAlerts();
      this.getAvgDailyDistance();
      this.getWaitTimeChart();
      // this.getTargetChart();
      this.getAvgMinuteLoadChart();
      this.getFluidByLoadChart();
      this.getFluidByUnloadChart();
      this.getTargetList();
      
    },
    tcFilter(tc_filter, id) {
      this.tc_filter = tc_filter;
      this.filter_by["trucking_company_id"] = id;
      if (id == 0) {
        this.filter_by["trucking_company_id"] = "";
      }
      this.loadingData = true;
      this.getDashboard();
      this.getAlerts();
      this.getAvgDailyDistance();
      this.getWaitTimeChart();
      // this.getTargetChart();
      this.getAvgMinuteLoadChart();
      this.getFluidByLoadChart();
      this.getFluidByUnloadChart();
      this.getTargetList();
      
    },
    oaFilter(oa_filter, id) {
      this.oa_filter = oa_filter;
      this.filter_by["operating_area_id"] = id;
      if (id == 0) {
        this.filter_by["operating_area_id"] = "";
      }
      this.loadingData = true;
      this.getDashboard();
      this.getAlerts();
      this.getAvgDailyDistance();
      this.getWaitTimeChart();
      // this.getTargetChart();
      this.getAvgMinuteLoadChart();
      this.getFluidByLoadChart();
      this.getFluidByUnloadChart();
      this.getTargetList();
    },
    getChartConfigs() {
      let app = this;
      dashboard_service.getChartConfigs().then(data => {
        this.list = data;
      });
    },
    ecFilter1(ec_filter, id) {
      this.ec_filter1 = ec_filter;
      this.filter_by1["energy_company_id"] = id;
      this.oa_filter1 = "All Operating Areas";
      if (id!==0) {       
        let pos = this.energy_companies_filter1
          .map(o => o.id)
          .indexOf(this.filter_by1["energy_company_id"]);
            if (pos > -1) {
                this.operating_areas_filter1     = this.energy_companies_filter1[pos].operating_areas;
                this.filter_by1["operating_area_id"] = ''
                this.location_list()
                this.load_locations_id    = []
                this.unload_locations_id  = []
                this.users_id             = [] 
                this.user_Change()
            } else {
                this.operating_areas_filter1     = []            
                this.loadlocationselect         = []
                this.unloadlocationselect       = [] 
                this.filter_by1["operating_area_id"] = '' 
                this.load_locations_id    = []
                this.unload_locations_id  = []
                this.users_id             = [] 
                this.user_Change()         
            }
      } else {
          this.filter_by1['energy_company_id'] = ''
          this.filter_by1["operating_area_id"] = ''
          this.ec_list()
          this.location_list()
          this.load_locations_id    = []
          this.unload_locations_id  = []
          this.users_id             = [] 
          this.user_Change()
      }
    },
    tcFilter1(tc_filter, id) {
      this.tc_filter1 = tc_filter;
      this.filter_by1["trucking_company_id"] = id;
 
      if (id!==0) {       
        let pos = this.trucking_companies_filter1
          .map(o => o.id)
          .indexOf(this.filter_by1["trucking_company_id"]);
            if (pos > -1) {
                this.energy_companies_filter1    = this.trucking_companies_filter1[pos].energy_companies;
                this.users_select                = this.trucking_companies_filter1[pos].drivers
                this.filter_by1['energy_company_id'] = ''
                this.filter_by1["operating_area_id"] = ''
                this.ec_list()
                this.location_list()
                this.load_locations_id    = []
                this.unload_locations_id  = []
                this.users_id             = []
                this.user_Change()
            } else {
                this.energy_companies_filter1         = []
                this.users_select                     = []
                this.filter_by1['energy_company_id']  = ''
                this.filter_by1["operating_area_id"]  = ''
                this.loadlocationselect   = []
                this.unloadlocationselect = [] 
                this.load_locations_id    = []
                this.unload_locations_id  = []
                this.users_id             = [] 
                this.user_Change()        
            }
      } else {
          this.filter_by1['energy_company_id'] = ''
          this.filter_by1["operating_area_id"] = ''
          this.ec_list()
          this.location_list()
          this.load_locations_id    = []
          this.unload_locations_id  = []
          this.users_id             = []
          this.user_Change()
      }   
    },
    iFilter1() {
      if (this.filter_by1["end_date"] == "" || !this.filter_by1["end_date"]) {
        this.filter_by1["end_date"] = "";
      }
    },
    eFilter1() {
      if (
        this.filter_by1["initial_date"] == "" ||
        !this.filter_by1["initial_date"]
      ) {
        this.filter_by1["initial_date"] = "";
      }
    },
    oaFilter1(oa_filter, id) {
      this.oa_filter1 = oa_filter;
      this.filter_by1["operating_area_id"] = id;
      if (id == 0) {
        this.filter_by1["operating_area_id"] = "";
      }
      this.location_list()
      this.load_locations_id    = []
      this.unload_locations_id  = []
    },
    clearFilters1() {

      this.ec_filter1 = "All Energy Companies"
      this.tc_filter1 = "All Trucking Companies"
      this.oa_filter1 = "All Operating Areas"
      this.filter_by1 = {
        energy_company_id: "",
        trucking_company_id: "",
        initial_date: moment()
          .startOf("month")
          .format("YYYY-MM-DD"),
        end_date: moment()
          .endOf("month")
          .format("YYYY-MM-DD"),
        operating_area_id: "",
        users               : [], 
        load_locations      : [],
        unload_locations    : [],  
      };
      this.loadlocationselect   = []
      this.unloadlocationselect = [] 
      this.load_locations_id    = []
      this.unload_locations_id  = []
      this.users_id             = []       
    },
    alert_filter(flag) {
      // `this` inside methods points to the Vue instance
      localStorage.setItem("dashboard", "dash08");
      localStorage.setItem("dashboard_start_date", this.filter_by.initial_date);
      localStorage.setItem("dashboard_end_date", this.filter_by.end_date);
      localStorage.setItem(
        "dashboard_energy_id",
        this.filter_by.energy_company_id
      );
      localStorage.setItem("dashboard_energy_name", this.ec_filter);
      localStorage.setItem(
        "dashboard_trucking_company_id",
        this.filter_by.trucking_company_id
      );
      localStorage.setItem("dashboard_trucking_company_name", this.tc_filter);
      localStorage.setItem("dashboard_flag_name", flag);
      var currentUrl = "http://" + window.location.host + "/#/hauls";
      window.location.href = currentUrl;
      return;
    },
    est_detail(est) {
      this.calculate = true;
      this.estimate_selling_price = est.variables;
      this.save_selling_price.location_id = est.location_id;
      this.save_selling_price.price = est.price;
      this.save_selling_price.variables = est.variables;
      this.save_selling_price.initial_date = est.initial_date;
      this.save_selling_price.end_date = est.end_date;
    },
    checkedField(var_name = null, index, chk) {
      let cad = var_name.slice(0, -1);
      let show_formula = this.show_formula;
      let newcad = show_formula.replace(cad, "excluded");
      // this.show_formula=newcad
    },
    save_formula() {
      this.calculate = false;
      this.save_selling_price.variables = this.estimate_selling_price;
      dashboard_service
        .Config_Formula(this.save_selling_price)
        .then(data => {
          this.$swal(data.status, data.message, data.status).then(result => {
            if (data.status == "success") {
              this.getDashboard();
              this.getAlerts();
              this.getAvgDailyDistance();
      this.getWaitTimeChart();
      // this.getTargetChart();
      this.getAvgMinuteLoadChart();
      this.getFluidByLoadChart();
      this.getFluidByUnloadChart();
      this.getTargetList();
            }
          });
        })
        .catch(error => {
          this.$swal("Error", "Server not response. " + error, "error");
        });
    },
    get_volume_by_date_chart() {
      this.filter_by1['load_locations']   = this.load_locations_id
      this.filter_by1['unload_locations'] = this.unload_locations_id
      dashboard_service
        .get_volume_by_date(this.filter_by1)
        .then(data => {
          if (data.status == "success") {
            this.chart = data.volume_by_date_chart
          }
        })
        .catch(error => {
          this.$swal("Error", "Server not response. " + error, "error");
          this.loadingData = false;
        });
    },
    get_volume_by_date_user_chart() {
      this.filter_by1['load_locations']   = this.load_locations_id
      this.filter_by1['unload_locations'] = this.unload_locations_id  
      this.filter_by1['users']            = this.users_id    
      dashboard_service
        .get_volume_user(this.filter_by1)
        .then(data => {
          if (data.status == "success") {
            this.chart_users = data.volume_by_date_user_chart
          }
        })
        .catch(error => {
          this.$swal("Error", "Server not response. " + error, "error");
          this.loadingData = false;
        });
    },
    LLToggleAll(checked) {
				this.load_locations_id = checked ? this.loadlocationselect.map(item => {
					return item.id
				}) : []
		},
		ULToggleAll(checked) {
				this.unload_locations_id = checked ? this.unloadlocationselect.map(item => {
					return item.id
				}) : []
		},
    user_ToggleAll(checked) {
				this.users_id = checked ? this.users_select.map(item => {
					return item.id
				}) : []
		},
		loadLocationsChange() {
				if (this.role =='super_admin') {
					if (this.load_locations_id.length === 0) {
						this.indeterminateLL = false
						this.llAllSelected = false
					} else if (this.load_locations_id.length === this.loadlocationselect.length) {
						this.indeterminateLL = false
						this.llAllSelected = true
					} else {
						this.indeterminateLL = true
						this.llAllSelected = false
					}
				}
		},
		unloadLocationsChange() {
				if (this.role =='super_admin') {
					if (this.unload_locations_id.length === 0) {
						this.indeterminateUL = false
						this.ulAllSelected = false
					} else if (this.unload_locations_id.length === this.unloadlocationselect.length) {
						this.indeterminateUL = false
						this.ulAllSelected = true
					} else {
						this.indeterminateUL = true
						this.ulAllSelected = false
				  }
				}
    },
    user_Change() {
				if (this.role =='super_admin') {
					if (this.users_id.length === 0) {
						this.indeterminate_user = false
						this.user_AllSelected = false
					} else if (this.users_id.length === this.users_select.length) {
						this.indeterminate_user = false
						this.user_AllSelected = true
					} else {
						this.indeterminate_user = true
						this.user_AllSelected = false
				  }
				}
    },
    location_list() {
      if (this.role =='super_admin') {   
        this.loadlocationselect   = []
        this.unloadlocationselect = []        
        let location = this.operating_areas_filter1       
        if (this.filter_by1["operating_area_id"] === "") {
            let new_unloadlocations = []
            let new_loadlocations   = []
            location.map( item => {
              item.loads.forEach( element => { 
                 let index2 = new_loadlocations.map(o => o.id).indexOf(element.id)
                 if (index2 < 0) {
                      new_loadlocations.push(element)
                 }
              })
              item.unloads.forEach( element => { 
                 let index1 = new_unloadlocations.map(o => o.id).indexOf(element.id)
                 if (index1 < 0) {
                      new_unloadlocations.push(element)
                 }
              })              
            })
            if (new_unloadlocations.length>0) {
                let mapped = new_unloadlocations.map(function(el, i) {
                    return { index: i, value: el.legal_location.toLowerCase() };
                })
                mapped.sort( (a,b) => {   if (a.value > b.value) {
                                              return 1;
                                          }
                                          if (a.value < b.value) {
                                              return -1;
                                          }
                                          return 0;
                                      })
                this.unloadlocationselect = mapped.map(function(el){
                                                        return new_unloadlocations[el.index];
                                                      });
            }
            if (new_loadlocations.length>0) {
                let mapped1 = new_loadlocations.map(function(el, i) {
                    return { index: i, value: el.legal_location.toLowerCase() };
                })
                mapped1.sort( (a,b) => {   if (a.value > b.value) {
                                              return 1;
                                          }
                                          if (a.value < b.value) {
                                              return -1;
                                          }
                                          return 0;
                                      })
                this.loadlocationselect = mapped1.map(function(el){
                                                        return new_loadlocations[el.index];
                                                      });
            }

        } else {
            let index =location.map(o => o.id).indexOf(this.filter_by1["operating_area_id"])
					  if (index > -1) {
              this.loadlocationselect = location[index].loads
              this.unloadlocationselect = location[index].unloads
            }            
        }
      }
    },
    user_list() {
      if (this.role =='super_admin') {  
        this.users_select   = []    
        let trucking_companies = this.trucking_companies_filter      
        if (this.filter_by["trucking_company_id"] === "") {            
            trucking_companies.map( item => {
              item.drivers.forEach( element => { 
                 this.users_select.push(element)
              })             
            })
        } else {
            let index =trucking_companies.map(o => o.id).indexOf(this.filter_by["trucking_company_id"])
					  if (index > -1) {
              this.users_select = trucking_companies[index].drivers
            }            
        }
      }
    },
    generate_chart_click() {
       this.get_volume_by_date_chart()
       this.get_volume_by_date_user_chart()
    },
    activate_chart_click() {
      if (this.role =='super_admin') { 
        this.chart_activated = !this.chart_activated
      }
      
    },
    dash_filter() {
      dashboard_service
        .dashboard_tc()
        .then(data => {
          if (data.status == "success") {
            this.trucking_companies_filter1 = data.trucking_company_filter
          } else {
            this.$swal(data.status, data.message, data.status);
            return;
          }
        })
        .catch(error => {
          this.$swal("Error", "Server not response. " + error, "error");
        });
    },
    ec_list() {
        this.operating_areas_filter1   = []    
        let energy_companies = this.energy_companies_filter1      
        if (this.filter_by1["energy_company_id"] === "") {            
            energy_companies.map( item => {
              item.operating_areas.forEach( element => { 
                 this.operating_areas_filter1.push(element)
              })             
            })
        } else {
            let index =energy_companies.map(o => o.id).indexOf(this.filter_by1["energy_company_id"])
					  if (index > -1) {
              this.operating_areas_filter1 = energy_companies[index].operating_areas
            }            
        }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Dashboard.vue